(function ($) {
    class W4D_Accordion {
        constructor() {
            this.initSelectors();
            this.bindEvents();
            this.setInitialStates(); // Set initial states for accordions
        }

        initSelectors() {
            this.triggers = $('.js-accordion-trigger');
            this.contents = $('.js-accordion-content');
            this.mediaQueryXs = window.matchMedia('(max-width: 576px)');
        }

        bindEvents() {
            this.triggers.on('click', (e) => {
                const $trigger = $(e.target);
                const $item = $trigger.closest('.js-accordion-item');
                const $content = $item.find('.js-accordion-content');

                // Close other items if needed
                if ($trigger.hasClass('active')) {
                    this.closeContent($content, $trigger);
                } else {
                    this.openContent($content, $trigger);
                }

                // Close other items in the same accordion
                this.contents.each((_, el) => {
                    const $el = $(el);
                    if ($el[0] !== $content[0] && $el.hasClass('active')) {
                        this.closeContent($el, $el.prev('.js-accordion-trigger'));
                    }
                });

                if (this.mediaQueryXs.matches) {
                    // Scroll to the currently opened item
                    setTimeout(() => {
                        this.handleMobileScroll($item);
                    }, 350); // Delay to allow animation to start
                }
            });
        }

        setInitialStates() {
            // Hide all content initially
            this.contents.each(function () {
                $(this).css({
                    height: '0',
                    overflow: 'hidden',
                    paddingBottom: '0',
                    display: 'none',
                }).removeClass('active');
            });
        }

        handleMobileScroll($accordionItem) {
            const $header = $('.w4d-header');
            const headerHeight = $header.length ? $header.outerHeight() : 0;
            const extraOffset = 20;

            const viewportHeight = window.innerHeight;
            const accordionItemPosition = $accordionItem.offset().top;
            const accordionItemHeight = $accordionItem.outerHeight();

            // Calculate if the expanded content will be visible
            const isItemTooTallForViewport = accordionItemHeight > (viewportHeight - headerHeight);

            setTimeout(() => {
                // If item is too tall, scroll to top of item
                // If item fits viewport, scroll to optimal viewing position
                let scrollPosition = isItemTooTallForViewport
                    ? accordionItemPosition - headerHeight - extraOffset
                    : accordionItemPosition - ((viewportHeight - accordionItemHeight) / 2) - headerHeight;

                window.scrollTo({
                    top: Math.max(0, scrollPosition),
                    behavior: 'smooth'
                });
            }, 350);
        }

        openContent($content, $trigger) {
            // Open the clicked content
            $content.css({
                display: 'block', // Make it visible to calculate height
                height: 'auto',
                overflow: 'hidden',
            });

            const fullHeight = $content[0].scrollHeight; // Get full height

            // Reset height to 0 for animation
            $content.css({
                height: '0',
                paddingBottom: '0',
            });

            // Trigger reflow for animation
            $content[0].offsetHeight;

            // Animate to full height
            $content.css({
                height: `${fullHeight}px`,
                paddingBottom: '17px', // Add padding for visual spacing
                transition: 'height 0.3s ease-out, padding-bottom 0.3s ease-out',
            });

            // Mark as active
            $content.addClass('active');
            if ($trigger) {
                $trigger.addClass('active').attr('aria-expanded', 'true');
            }
        }

        closeContent($content, $trigger) {
            if (!$content.hasClass('active')) return;

            // Set current height for animation
            const currentHeight = $content.height();

            $content.css({
                height: `${currentHeight}px`,
                overflow: 'hidden',
                paddingBottom: '17px', // Keep padding during animation start
                transition: 'height 0.3s ease-out, padding-bottom 0.3s ease-out',
            });

            // Trigger reflow for animation
            $content[0].offsetHeight;

            // Animacija faq/checkout
            setTimeout(() => {
                $content.css({
                    height: '0',
                    paddingBottom: '0',
                });
            }, 10);

            // Remove active class and hide after animation completes
            setTimeout(() => {
                $content.css({ display: 'none' }).removeClass('active');
                if ($trigger) {
                    $trigger.removeClass('active').attr('aria-expanded', 'false');
                }
            }, 300); // Match duration with CSS transition time (300ms)
        }
    }

    $(document).ready(() => {
        new W4D_Accordion();
    });
})(jQuery);